
function init() {
    const headerBurger = document.querySelector('.header-burger')
    const headerBurgerMenu = document.querySelector('.header-burger__menu')
    const headerHover = document.querySelector('.header__hover')

    headerBurger.addEventListener('click', function(){
        const sticks = this.querySelector('.header-burger__ico')
        const cross = this.querySelector('.header-burger__icon')

        sticks.classList.toggle('d-block')
        cross.classList.toggle('d-block')

        headerBurgerMenu.classList.toggle('d-block')
        headerHover.classList.toggle('d-block')
    })

    const menuItems = document.querySelectorAll('.burger-menu__link')

    menuItems.forEach(item => {
        item.querySelector('.burger-menu__item').addEventListener('click', function(){
            menuItems.forEach(element => {
                element.classList.remove('burger-menu__link--isActive')
            });

            item.classList.toggle('burger-menu__link--isActive')
        })
    })
}   



export default {
	init
};
